export default "__VITE_ASSET__f7c6a4c9__"